import AmenitiesDisplay from '@/components/amenities-display'
import { SectionHeader } from '@/components/headings'
import Section from '@/components/section'
import { isNullOrEmpty } from '@/utils'

const Amenities = ({ amenities = [], customAmenities, unitScope, header, translationContext }) => {
  if (isNullOrEmpty(amenities) && isNullOrEmpty(customAmenities)) return null

  return (
    <Section>
      <SectionHeader>{header}</SectionHeader>
      <AmenitiesDisplay
        translationContext={translationContext}
        amenities={amenities}
        customAmenities={customAmenities}
        showType={unitScope !== 'entire'}
      />
    </Section>
  )
}

export default Amenities
